import Sidebar from "./Components/Sidebar";
import AppRoutes from "./AppRoutes";
import { useLocation } from "react-router-dom";
import { Grid, Card, CardContent, Typography, Box } from "@mui/material";

function App() {
  const location = useLocation();
  const isLoginPage =
    location.pathname === "/" ||
    location.pathname === "/login" ||
    location.pathname.startsWith("/reset-password/");

  console.log(isLoginPage + "is Login");
  return isLoginPage ? (
    // 🔹 Show only login page without sidebar
    <>
      <AppRoutes />
    </>
  ) : (
    <Box sx={{ display: "flex" }}>
      <Sidebar />
      <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
        <>
          <AppRoutes />
        </>
      </Box>
    </Box>
  );
}

export default App;
